export const Bio = {
  name: "Omkar Sharma",
  roles: ["Cloud DevOps Engineer", "Career Mentor","Full Stack Developer", "Corporate Trainer"],
  newroles: ["Build", "Deploy", "Optimize", "Automate"],
 description: `How I Can Add Value to Your Career and Business? 
  ● 3 years in Career guidance, planning, & mentoring.
  ● Build modern, responsive websites from scratch.  
  ● Deploy and manage applications end-to-end.  
  ● Optimize cloud infrastructure for cost & performance.  
  ● Develop custom AI agents and Automation Tools.`,
  github: "https://github.com/omkarsharma2821",
  resume:
    "https://drive.google.com/file/d/1egIetC79I8vVSCuKqrEKtgZZ08igMyuk/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/omkarsharmaa/",
  x: "https://x.com/OmiiPandit",
  insta: "https://www.instagram.com/omkarsharmaa_/",
  git: "https://github.com/omkarsharma2821/",
  medium: "https://medium.com/@omkarsharma2821",
  dev: "https://dev.to/omkarsharma2821",
};

export const skills = [
  {
    title: "DevOps & Cloud",
    skills: [
      {
        name: "Azure",
        image: "https://shorturl.at/NZN6y",
      },
      {
        name: "AWS",
        image: "https://images.icon-icons.com/2389/PNG/512/amazon_aws_logo_icon_145507.png",
      },
      {
        name: "GCP",
        image: "https://shorturl.at/UyaUv",
      },
      {
        name: "Linux",
        image: "https://tinyurl.com/2zv8ynvd",
      },
      {
        name: "Github Actions",
        image: "https://tinyurl.com/yeyskras",
      },
      {
        name: "Jenkins",
        image: "https://images.icon-icons.com/2699/PNG/256/jenkins_logo_icon_170552.png",
      },
      {
        name: "Windows",
        image: "https://tinyurl.com/bdfe45tc",
      },
      {
        name: "Git",
        image: "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://cdn-icons-png.flaticon.com/128/919/919853.png",
      },
      {
        name: "Terraform",
        image:
          "https://images.icon-icons.com/2107/PNG/512/file_type_terraform_icon_130125.png",
      },
      {
        name: "PowerShell",
        image:
          "https://images.icon-icons.com/2148/PNG/96/powershell_icon_132080.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://images.icon-icons.com/2699/PNG/512/kubernetes_logo_icon_168359.png",
      },
    ],
  },
  {
    title: "Development",
    skills: [
      {
        name: "React Js",
        image:
          "https://tinyurl.com/4wta79nb",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://images.icon-icons.com/2107/PNG/512/file_type_css_icon_130661.png",
      },
      {
        name: "JavaScript",
        image:
          "https://images.icon-icons.com/2108/PNG/512/javascript_icon_130900.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image: "https://images.icon-icons.com/3913/PNG/512/mui_logo_icon_248416.png",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Next Js",
        image: "https://www.datocms-assets.com/98835/1684410508-image-7.png",
      },
      {
        name: "Express Js",
        image: "https://tinyurl.com/34h2vbx2",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "C++",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
      },
      {
        name: "Python",
        image: "https://tinyurl.com/49d9542p",
      },
      {
        name: "Javascript",
        image:
          "https://images.icon-icons.com/2108/PNG/512/javascript_icon_130900.png",
      },
      {
        name: "JSON",
        image:
          "https://img.shields.io/badge/-black?&logo=mendeley&logoColor=white",
      },
    ],
  },
  {
    title: "Other Tools",
    skills: [
      {
        name: "VS Code",
        image:
          "https://images.icon-icons.com/2107/PNG/512/file_type_vscode_icon_130084.png",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Canva",
        image:
          "https://images.icon-icons.com/3504/PNG/96/canva_icon_220714.png",
      },
      {
        name: "Advance Excel",
        image:
          "https://images.icon-icons.com/195/PNG/96/Excel_2013_23480.png",
      },
      {
        name: "Microsoft Word",
        image:
          "https://images.icon-icons.com/2570/PNG/96/word_mac_icon_153770.png",
      },
      {
        name: "Render",
        image:
          "https://img.shields.io/badge/-black?style=for-the-badge&logo=render&logoColor",
      },
      {
        name: "Netlify",
        image:
          "https://images.icon-icons.com/2699/PNG/96/netlify_logo_icon_169924.png",
      },
      {
        name: "Vercel",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/vercel/vercel-original-wordmark.svg",
      },
      {
        name: "Mendeley",
        image:
          "https://img.shields.io/badge/-black?&logo=mendeley&logoColor=white",
      },
      {
        name: "Power BI",
        image:
          "https://images.icon-icons.com/3660/PNG/96/data_office_power_bi_logo_microsoft_icon_228487.png",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://tinyurl.com/3be2s5u7",
    role: "Cloud DevOps Engineer",
    company: "HCLTech",
    date: "Nov 2024– Present",
    desc: "● Automated and developed Azure Logic Apps to deliver real-time security alerts and vulnerability reports from Microsoft Defender and Azure Monitor to subscription owners, improving incident visibility and reducing response time.● Designed cloud architecture and end-to-end environment setup for new accounts using draw.io and other design tools.● Developed patch baselines and policy configurations for both Linux and Windows machines.● Automated patching during maintenance windows.● Automated AWS immutable backups for critical resources, optimizing costs by removing resources as planned.● Automated detection and cleanup of unused and idle AWS resources (EBS, RDS, EKS, etc.) using CloudWatch and Lambda to optimize cloud costs resulting a 40%+ cost savings across multiple environments.● Developed secure and scalable landing zones on AWS and Azure for new clients.● Identified gaps in cloud setups and fixed them using automation and manual configs.● Designed and implemented end-to-end network architectures, including firewalls and WAFs. ● Led clients to understand their needs and suggest best-fit cloud solutions.",
    skills: ["Azure", "AWS", "Linux", "Cloud Automation", "Cloud Architecture", "Cost Optimization", "Security & Compliance", "Landings Zones", "Network Architecture"],
    // doc: "https://drive.google.com/file/d/19dHIaj-lnkeigz6p0hcQklnjPuOT2ts8/view?usp=sharing",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/D560BAQFu4sk6KZlRGA/company-logo_200_200/B56ZndKG8qG0AI-/0/1760352039369/hypertechglobaltechnologies_pvt_ltd_logo?e=1776297600&v=beta&t=j4vZ1w3VE9-mcpZ9LjE2EdHuL3K8OuNixcLnCe3QHDo",
    role: "Cloud & DevOps Trainer",
    company: "HYPERTECHGLOBALTECHNOLOGIES PVT LTD - Remote",
    date: "Nov 2026– Present",
    desc: "● Mentoring working professionals from support, operations, and non-technical backgrounds to upskill and successfully transition into DevOps roles.",
    skills: ["Docker","Jenkins","Kubernetes","Terraform","DevOps", "Linux","Cloud Computing", "CI/CD"],
    // doc: "https://drive.google.com/file/d/19dHIaj-lnkeigz6p0hcQklnjPuOT2ts8/view?usp=sharing",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/D560BAQHTItv8wJEm3w/company-logo_200_200/company-logo_200_200/0/1732884498456/cipherschool_logo?e=1776297600&v=beta&t=Lt1IadkKxBiOa_lBGmece7e4r38rfrEEoVrwp4SmTRU",
    role: "Content Strategist",
    company: "CipherSchools - Remote",
    date: "May 2025– Jul 2025",
    desc: "● Designed and delivered 22+ hours of structured cloud computing content, empowering 50+ engineering students from top universities to gain hands-on expertise in Cloud and DevOps.● Hosted 15+ live sessions and webinars across platforms, simplifying complex concepts and increasing learner engagement and query resolution by 95%.● Mentored 70+ students on academic and industry projects, helping them complete projects successfully, contribute to research, and become career-ready.",
    skills: [
      "Teaching & Training","Cloud & DevOps","Content Creation","Live sessions","Mentoring","Project Guidance"],
    // doc: "https://drive.google.com/file/d/19dHIaj-lnkeigz6p0hcQklnjPuOT2ts8/view?usp=sharing",
  },
  {
    id: 3,
    img: "https://shorturl.at/CbvnK",
    role: "Technical Trainer",
    company: "LogicPro InfoSystems – Lucknow",
    date: "Aug 2024 - Oct 2024",
    desc: "Responsible for preparing, conducting, and evaluating technical training on latest technologies for Students and Working Professionals. Analyze learning needs and develop appropriate training material. Interact with respective departments in scheduling training programs.",
    skills: [
      "O'Level","Web Designing","IOT Tools","Python","DSA","C","C++",],
    // doc:""
  },
  {
    id: 4,
    img: "https://media.licdn.com/dms/image/v2/C510BAQHMTTTI3BTfcQ/company-logo_200_200/company-logo_200_200/0/1630586600589/digipodium_logo?e=1776297600&v=beta&t=hFlSrbIkv4bRhGMDFI1lj1XDQm11mItB3I1C8d8b4S0",
    role: "MERN Stack Intern",
    company: "Digipodium – Lucknow",
    date: "Aug 2023 - Oct 2023",
    desc: "Proficiency in React's foundational principles, including JSX, components, props, state, lifecycle methods, and hooks, is essential. Additionally, the ability to construct an entire website using React for the frontend, MongoDB for the database, Express for the backend, and Node.js for the runtime environment is paramount.",
    skills: [
      "React Js",
      "Node Js",
      "MongoDB",
      "Express",
      "JavaScript",
      "Material UI",
      "Postman",
      "SEO",
      "Netlify",
      "Render",
      "Git",
      "GitHub",
    ],
    // doc:""
  },
  {
    id: 6,
    img: "https://internshala.com//static/images/internshala_og_image.jpg",
    role: "Web Development",
    company: "Internshala",
    date: "2022",
    desc: "Built user friendly PG managing website helpful in finding the nearest PG and Rooms for students.",
    skills: ["HTML", "CSS", "Bootstrap", "JavaScript"],
    // doc: "https://drive.google.com/file/d/1iius6V9HRWfHU6lNNbxnc6b23vRrA_rb/view?usp=sharing",
  },
  {
    id: 5,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIzIBYqgbXSbU1K96WWHvPnfFKxowlQZuklg&s",
    role: "Full Stack Intern",
    company: "Robustresults Pvt ltd, IITK",
    date: "Oct 2021–Nov 2021",
    desc: "Leveraged my full-stack developer skills in HTML, CSS, JavaScript, Bootstrap, PHP, and MySQL during a 6-week internship at Robustresults Pvt. Ltd., an IITK incubated company.",
    skills: ["HTML", "Bootstrap", "CSS", "JavaScript", "GitHub"],
    // doc: "https://drive.google.com/file/d/19dHIaj-lnkeigz6p0hcQklnjPuOT2ts8/view?usp=sharing",
  },
];

export const education = [
  {
    id: 0,
    img: "https://tse1.explicit.bing.net/th?id=OIP.I2N7PDgOzS0DrHDJfYws5AAAAA&pid=Api&P=0&h=180",
    school: "Babu Banarasi Das Institute of Technology and Management, Lucknow",
    date: "Aug 2020 - July 2024",
    grade: "8.44/10 CGPA",
    desc: "I have completed my Bachelor's degree in Computer Science and Engineering in 2024 from Babu Banarasi Das Institute of Technology and Management, Lucknow. My major coursework included Data Structures and Algorithm, Operating System, Computer Networks, Database Management System, Software Engineering, and Software Testing.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering.",
  },
  {
    id: 1,
    img: "https://tse1.mm.bing.net/th?id=OIP.tvv0GQrwuj3KYWgFlle1wQHaHR&pid=Api&P=0&h=180",
    school: "Girish Prasad Memorial College, Bareilly",
    date: "Apr 2017 - Apr 2019",
    grade: "81.5%",
    desc: "I completed my Class 12th education at Girish Prasad Memorial College, Bareilly. During my studies there, I studied the PCM stream and picked Computer Science from elective subject.",
    degree: "ISC(XII), PCM with Computer",
  },
  {
    id: 2,
    img: "https://tse2.mm.bing.net/th?id=OIP.OHv7TqRnKOqAjLpRwTBNnQAAAA&pid=Api&P=0&h=180",
    school: "St Mary's Convent School, Bareilly",
    date: "Apr 2017",
    grade: "72.8%",
    desc: "I completed my Class 10th education at St Mary's Convent School, Bareilly. During my studies there, I undertook the PCM stream with Computer Science.",
    degree: "ICSC(X)",
  },
];

export const projects = [
  {
    id: 9,
    title: "VintiMart",
    // date: "Nov 2023 - Dec 2023",
    description:
      "It is for furniture lovers seeking to add a touch of elegance to their homes without breaking the bank.It extends a helping hand to those seeking to furnish their homes with dignity and grace also empowers both the furniture donor and the recipient, fostering a spirit of community and shared purpose.",
    image:
      "https://raw.githubusercontent.com/omkarsharma2821/Portfolio/main/screenshot/Screenshot%202023-12-14%20194816.png",
    tags: [
      "React Js",
      "Node Js",
      "MongoDB",
      "Express",
      "JavaScript",
      "Material UI",
      "Postman",
      "Render",
    ],
    category: "website",
    github: "https://github.com/omkarsharma2821/VintiMart",
    webapp: "https://vintimart-9x78.onrender.com/",
  },
  {
    id: 0,
    title: "Green Doctor ",
    // date: "Present",
    description:
      "Web Based Solution to identify and solve disease in plants/crops–Smart India Hackathon 2023. Provides tailored treatment plans and proactive measures to combat plant disease. Designed for urban farmers, farmers and amateur gardener to protect their crops/plants and boost production.",
    image:
      "https://raw.githubusercontent.com/omkarsharma2821/Portfolio/main/screenshot/Screenshot%202024-06-05%20150144.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Nodemailer",
      "Socket.io",
      "JsonWebToken",
      "Vite",
      "Material UI",
      "AI",
      "TensorFLow",
      "Teachable Machine",
    ],
    category: "website",
    github: "https://github.com/omkarsharma2821/Green-Doctor",
    webapp: "https://green-doctor.onrender.com/main/home",
    member: [
      {
        name: "Omkar Sharma",
        img: "https://avatars.githubusercontent.com/u/104587783?s=96&v=4",
        linkedin: "https://www.linkedin.com/in/omkarsharmaa/",
        github: "https://github.com/omkarsharma2821/",
      },
      {
        name: "Rasheeq Zehra",
        img: "https://avatars.githubusercontent.com/u/108568853?v=4",
        linkedin: "https://www.linkedin.com/in/rasheeq-zehra-mern-developer/",
        github: "https://github.com/rasheeq123",
      },
    ],
  },
  {
    id: 6,
    title: "SkyCast",
    description:
      "This is React App is build to test the EC2 instance. It is a weather app that shows the current weather of the city entered by the user. It uses OpenWeather API to fetch the data and show it to the user. The app is hosted on AWS EC2 instance.",
    image:
      "https://raw.githubusercontent.com/omkarsharma2821/Portfolio/main/screenshot/skycast.png",
    tags: ["AWS", "EC2", "SSH", "React Js"],
    category: "webpage",
    github: "https://github.com/omkarsharma2821/Weather-App",
    webapp: "https://weatherwale.netlify.app/",
  },
  {
    id: 1,
    title: "PG Life",
    // date: "2022",
    description:
      "Designed and developed user friendly PG management website helpful in finding the nearest PG and Rooms for students. The plan is to add all the affordable rooms and flat to help students.",
    image:
      "https://raw.githubusercontent.com/omkarsharma2821/Portfolio/main/screenshot/Screenshot%202024-01-01%20120410.png",
    tags: ["HTML", "CSS", "Bootstrap", "React", "JavaScript"],
    category: "website",
    github: "https://github.com/omkarsharma2821/PGLife",
    webapp: "https://github.com/omkarsharma2821/PGLife",
  },
  {
    id: 5,
    title: "Movie Review",
    // date: "June 2021",
    description:
      "A simple website that shows the rating of the famous movies and allow viewers to rate the movies on basis of their likes and dislikes. The site also has a search bar to search for a particular movie.",
    image:
      "https://raw.githubusercontent.com/omkarsharma2821/Portfolio/main/screenshot/Screenshot%202024-01-01%20120410.png",
    tags: ["React Js", "API", "Axios", "Node JS"],
    category: "website",
    github: "https://github.com/omkarsharma2821/fullstack-movie-project",
    webapp: "https://github.com/omkarsharma2821/fullstack-movie-project",
  },
  {
    id: 5,
    title: "Number Spy",
    // date: "June 2021",
    description:
      "Number Spy is an interactive number guessing game where users try to guess a secret number between 1 and 100 within 10 attempts. The project showcases dynamic game mechanics and clean user interaction through a simple yet engaging interface.",
    image:
      "https://raw.githubusercontent.com/omkarsharma2821/Portfolio/main/screenshot/Screenshot%202024-09-21%20170327.png",
    tags: ["Javascript", "HTML", "CSS"],
    category: "website",
    github:
      "https://github.com/omkarsharma2821/Javascript/tree/main/project/no.guessing",
    webapp: "https://numberspy.vercel.app/",
  },
  {
    id: 6,
    title: "Todo List",
    description:
      "A Todo List made with React JS and Bootstrap. It has a login page where users can log in with Registered account. It has a Text-box where users can set their tasks and can Delete them after completing the task.",
    image:
      "https://raw.githubusercontent.com/omkarsharma2821/Portfolio/main/screenshot/Screenshot%202024-01-01%20122050.png",
    tags: ["React Js", "MongoDB", "User Auth", "Bootstrap", "CSS", "HTML"],
    category: "webpage",
    github: "https://github.com/omkarsharma2821/React/",
    webapp: "https://github.com/omkarsharma2821/React/",
  },
];

export const certificates = [
  {
    id: 0,
    title: "Microsoft Certified: Azure Solutions Architect Expert",
    issuer: "Microsoft",
    image: "https://images.credly.com/size/680x680/images/987adb7e-49be-4e24-b67e-55986bd3fe66/azure-solutions-architect-expert-600x600.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-gb/OmkarSharma-1199/B66430E6C7667285?sharingId=ED5AC550E5F204F0",
  },
  {
    id: 1,
    title: "Microsoft Certified: DevOps Engineer Expert",
    issuer: "Microsoft",
    image: "https://images.credly.com/size/680x680/images/c3ab66f8-5d59-4afa-a6c2-0ba30a1989ca/CERT-Expert-DevOps-Engineer-600x600.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-gb/OmkarSharma-1199/A762B91143BAD0A1?sharingId=ED5AC550E5F204F0",
  },
  {
    id: 1,
    title: "Microsoft Certified: Azure AI Engineer Associate",
    issuer: "Microsoft",
    image: "https://images.credly.com/size/680x680/images/61f56aa4-16fd-403c-90bc-1d90dba1fa99/image.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-gb/OmkarSharma-1199/A04985B245717D15?sharingId=ED5AC550E5F204F0",
  },
  {
    id: 2,
    title: "Microsoft Certified: Azure Administrator Associate",
    issuer: "Microsoft",
    image: "https://images.credly.com/size/680x680/images/336eebfc-0ac3-4553-9a67-b402f491f185/azure-administrator-associate-600x600.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-gb/OmkarSharma-1199/6CFAEDE2349DA764?sharingId=ED5AC550E5F204F0",
  },
  {
    id: 3,
    title: "Associate Cloud Engineer Certification",
    issuer: "Google Cloud",
    image: "https://images.credly.com/size/680x680/images/08096465-cbfc-4c3e-93e5-93c5aa61f23e/image.png",
    link: "https://www.credly.com/badges/8159ed6b-643f-40a1-ae35-ffd81124fa83/public_url",
  },
  {
    id: 4,
    title: "Oracle Cloud Infrastructure 2025 Certified Data Science Professional",
    issuer: "Oracle",
    image: "https://brm-workforce.oracle.com/pdf/certview/images/OCI25DSOCP.png",
    link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=EB7EC19AEDA67B3BA4AE64F1B2D1AFFF9E16E92AD9C996D3D21E69EF54803214",
  },
  {
    id: 5,
    title: "GitHub Foundations by GitHub",
    issuer: "GitHub",
    image: "https://images.credly.com/size/680x680/images/024d0122-724d-4c5a-bd83-cfe3c4b7a073/image.png",
    link: "https://www.credly.com/badges/45a34fc4-9085-4abe-8c26-e92f7a2a3f5e/public_url",
  },
  {
    id: 6,
    title: "Microsoft Certified: Security, Compliance, and Identity Fundamentals",
    issuer: "Microsoft",
    image: "https://images.credly.com/size/680x680/images/fc1352af-87fa-4947-ba54-398a0e63322e/security-compliance-and-identity-fundamentals-600x600.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-gb/OmkarSharma-1199/8F9A9FBA16C72CEC?sharingId=ED5AC550E5F204F0",
  },
  {
    id: 7,
    title: "Microsoft Certified: Azure Fundamentals",
    issuer: "Microsoft",
    image: "https://images.credly.com/size/680x680/images/be8fcaeb-c769-4858-b567-ffaaa73ce8cf/image.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-gb/OmkarSharma-1199/51ECBCCE4FE6FF43?sharingId=ED5AC550E5F204F0",
  },
];